<div class="newsfeedlist-container">

    <mat-card class="newsfeedlist-content">
        <div class="card-contents">
            <div class="rowTwo">
                <mat-card-title>
                    <h2 class="card-title">Newsfeed for Agencies</h2>
                </mat-card-title>
                <div class="actions-box">
                    <mat-form-field appearance="outline" class="newsfeedlist-search">
                        <input matInput #search (keyup)="applyFilter($event)" placeholder="Search" />
                        <mat-icon matSuffix>search</mat-icon>

                    </mat-form-field>
                </div>
            </div>
            
            <mat-card-content class="newsfeed-content">

                <table mat-table [dataSource]="dataSource" matSort class="newsfeedlist-table agentlist-table">
                    <ng-container matColumnDef="Title">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element" class="testme">
                            <a class="links" [routerLink]="['./viewnewsfeed', element.NewsfeedID]"> {{ element.Title }}
                            </a>
                            <p>{{ element.Headline }}</p>
                            <p class="post-date">Posted: {{ element.PublishedDate |  date: 'mediumDate'}}</p>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let element; columns: displayedColumns" class="newsfeedlist-rows"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons> </mat-paginator>
            </mat-card-content>
        </div>
    </mat-card>
</div>